import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Guid } from "../../../api/baseApi";
import { addCampaignMedia, AddCampaignMediaRequest, CampaignMediaItem, CampaignPeriod, CampaignStatus, CampaingListModel, deleteCampaign, deleteCampaignMedia, getCampaignMedia, getCampaigns, pauseCampaign, pauseCampaignMedia, ChangeStatusCampaignMediaRequest, publishCampaign, StopPlayRequest, playCampaignMedia, getCampaignsArchived, uploadMediaForCampaign, postMediaCampaignVast, CampaignMediaScheduleRequest, postCampaignMediaSchedulePeriod, getCampaignMediaSchedule, CampaignMediaScheduleResponse, deleteCampaignMediaSchedulePeriod, postCampaignLock, postCampaignUnlock, postCampaignHiveStack, SwapCampaignMediaRequest, swapCampaignMedia} from "../../../api/campaingsApi";
import { getBaseChannels, SiteNestedPlaylistForCampaign } from "../../../api/channelsApi";
import { getMedia, getMediaById, getMediaCategories, HiveStackRequest, MediaContentType, MediaContentTypeOption, mediaContentTypeOptions, MediaModel, MediaType, updateMedia } from "../../../api/mediaApi";
import { addLeadingZero, formatDuration } from "../../../services/common";
import { formatDate, formatTimeOnly, convertUTCDateToLocalDate } from "../../../services/dateService";
import { Button } from "../../components/Button";
import { FormInput, FormRow, SelectOption } from "../../components/formRow/FormRow";
import IconButton from "../../components/iconButton/IconButton";
import Search from "../../components/search/Search";
import GlobalSpinner from '../../components/globalsSpinner/GlobalSpinner';
import {RightModal, CenterModal, SmallModal } from "../../components/sideModal/Modal";
import InnerLayout from "../innerLayout/InnerLayout";
import "./../../styles/formControls.css";
import "./Campaign.css";
import SvgSelector from "../../components/svgSelector/SvgSelector";
import { SelectMultipleFileButton } from "../../components/selectFileButton/SelectFileButton";
import FileInfoImage from "../../components/fileInfo/FileInfo";
import CampaignModal from "../../components/campaignModal/CampaignModal";
import Select, { SingleValue } from "react-select";
import { getPagesCount } from "../../../services/paginator";
import Pagination from "../../components/pagination/Pagination";
import moment from "moment";
import hiveStackIMG from './../../images/icons/hivestack.jpg';

export interface CampaignsProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse : () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string} 

export type CampaignsState = 
{
    showCampaignModal: boolean,
    showMediaModal: boolean,
    showDeleteModal: boolean,
    showGlobalSpinner: boolean,
    showArchivedCampaigns: boolean,
    showVASTModal: boolean,

    clientToggle? : boolean,
    campaigns : CampaingListModel[],
    loadStatus: "loading" | "loaded",
    createClientName : string,    
    selectedClientId: string,
    campaignName: string,
    channelOptions: SelectOption[],
    tagsOptions: SelectOption[],
    selectedChannels: Guid[],
    selectedTags: Guid[],
    selectedStatusOption: number | undefined

    periods: CampaignPeriod[],
    periodStart: string,
    periodEnd: string,

    isNameError: boolean,
    isSelectedClientError:boolean,
    isClientNameError: boolean,
    isPeriodStartError: boolean,
    isPeriodEndError: boolean,
    isPeriodError: boolean,
    isChannelsError: boolean,
    isTagError : boolean

    isShowMedia:boolean,
    campaignMedia : CampaignMediaItem[],
    media: MediaModel[],
    selectedMedia: {id: string, index: number}[],
    campaignId: Guid,
    
    campaignForDeleteId : Guid,
    campaignForDelete: string,
    
    searchString: string,
    currentPage: number,

    searchCampaignNameString: string,
    currentPageOfCamapigns: number,

    vastName: string,
    isVastNameError: boolean,
    vastUrl: string
    isVastUrlError: boolean,
    clockID: string,

    showHiveStackModal:boolean,
    hiveStackName: string,
    isHiveStackNameError: boolean,
    hiveStackClockId: string,
    selectedHiveStackContentTypeOption: SingleValue<MediaContentTypeOption>,

    campaignMediaInfo: CampaignMediaItem | null,
    showCampaignMediaInfoModal: boolean,

    mediaInfo: MediaModel,

    isShowScheduleModal: boolean,
    mediaPeriodName: string,
    isMediaPeriodNameError: boolean,
    mediaPeriodStart: string,
    isMediaPeriodStartError: boolean,
    mediaPeriodEnd: string,
    isMediaPeriodEndError: boolean,
    mediaIdForSetSchedule: Guid,
    campaignMediaSchedule: CampaignMediaScheduleResponse[],
    campaignPeriods: CampaignPeriod[],

    mediaPeriodStartTime: string,
    mediaPeriodEndTime: string,
    isMediaPeriodEndTimeError: boolean,

    campaignForEdit : CampaingListModel | undefined,

    selectedContentTypeOption: SingleValue<MediaContentTypeOption>,

    mediaCategories: Option<number>[],
    selectedMediaCategory: SingleValue<Option<number>>,

    isSwapModeActive: boolean,
    swappedMediaId:Guid,

    editingPeriodId: Guid | null,
    editPeriodName: string,
    editPeriodStart: string,
    editPeriodEnd: string,
    editPeriodStartTime: string,
    editPeriodEndTime: string,
    isEditPeriodEndError: boolean,
    isEditPeriodEndTimeError: boolean
}

class Campaigns extends React.Component<CampaignsProps, CampaignsState> {
    constructor(props: CampaignsProps) {
        super(props);
    }

    mediaItemsPerPage = 12;
    camapignPerPage = 20;

    statusOptions = [
        {
            type:CampaignStatus.Draft,
            name:"Draft"
        },
        {
            type:CampaignStatus.Scheduled,
            name:"Scheduled"
        },
        {
            type:CampaignStatus.Active,
            name:"Active"
        },
        {
            type:CampaignStatus.Expired,
            name:"Expired"
        },
        {
            type:CampaignStatus.Paused,
            name:"Paused"
        },
    ];

    override async componentWillMount(){
        this.setState({
            showGlobalSpinner: false,
            showArchivedCampaigns: false,
            showVASTModal: false,
            clientToggle:false,
            loadStatus : "loading",
            isNameError: false,
            isSelectedClientError:false,
            isClientNameError: false,
            isPeriodStartError: false,
            isPeriodEndError: false,
            isPeriodError:false,
            isShowMedia: false,
            isChannelsError: false,
            campaignMedia: [],
            selectedMedia: [],
            campaigns: [],
            channelOptions: [ { name : "Some", value : "1"}],
            selectedChannels: [],
            selectedTags:[],
            isTagError: false,


            searchString: '',
            currentPage: 1,

            selectedStatusOption: undefined,

            searchCampaignNameString: '',
            currentPageOfCamapigns: 1,

            vastName: '',
            isVastNameError: false,
            vastUrl: '',
            isVastUrlError: false,
            clockID: '',

            showHiveStackModal:false,
            hiveStackName: '',
            isHiveStackNameError: false,
            hiveStackClockId:'',

            selectedHiveStackContentTypeOption: mediaContentTypeOptions[0],

            campaignMediaInfo: null,
            showCampaignMediaInfoModal:false,

            isShowScheduleModal: false,
            mediaPeriodName: '',
            isMediaPeriodNameError: false,
            periodStart: '',
            isMediaPeriodStartError: false,
            periodEnd: '',
            isMediaPeriodEndError: false,
            mediaIdForSetSchedule: '',
            campaignMediaSchedule: [],
            campaignPeriods:[],

            mediaPeriodStart: '',
            mediaPeriodEnd: '',
            mediaPeriodStartTime: '',
            mediaPeriodEndTime: '',
            isMediaPeriodEndTimeError: false,

            campaignForEdit: undefined,

            selectedContentTypeOption: mediaContentTypeOptions[0],

            mediaCategories: [],
            selectedMediaCategory: null,

            isSwapModeActive: false,
            swappedMediaId: '',

            editingPeriodId: null,
            editPeriodName: '',
            editPeriodStart: '',
            editPeriodEnd: '',
            editPeriodStartTime: '',
            editPeriodEndTime: '',
            isEditPeriodEndError: false,
            isEditPeriodEndTimeError: false
        });
     
        await Promise.all([this.updateList(),this.updateChannelsBaseOptions(),this.updateMediaCategories()])
        
    }

    updateList = async () => {
        this.setState({loadStatus: "loading", showArchivedCampaigns:false, showGlobalSpinner:true});

        var getCampaignsResponse = await getCampaigns();
        switch(getCampaignsResponse.type){
            case "succes" :{
                this.setState({campaigns : getCampaignsResponse.data.campaigns, loadStatus: "loaded", showGlobalSpinner:false});
            }
        }  
    }

    updateChannelsBaseOptions = async () => {
        let channelsResult = await getBaseChannels();
        if(channelsResult.type == "succes") this.setState({channelOptions : channelsResult.data.items.map(it => { return {name: it.name, value: it.id}})})
    }

    showArchivedCampaignsList = async () =>{
        this.setState({loadStatus: "loading", showArchivedCampaigns: true, showGlobalSpinner:true});
        await this.updateArchivedList();
        this.setState({loadStatus: "loaded", showGlobalSpinner:false})
    }

    updateArchivedList = async () => {
        var getCampaignsResponse = await getCampaignsArchived();
        switch(getCampaignsResponse.type){
            case "succes" :{
                this.setState({campaigns : getCampaignsResponse.data.campaigns, loadStatus: "loaded"});
            }
        } 
    }

    async updateMediaCategories() {
        let result = await getMediaCategories();
        if(result.type == "succes") {
            this.setState({mediaCategories: result.data.items.map(it => {
                return {value: it.id, label: it.name}
                })
            }); 
        }
    }

    renderPeriod = (period: CampaignPeriod, i:number) =>{
        return <p key={i}>{formatDate(period.startDate)}-{formatDate(period.endDate)}</p>
    }

    pause = async (id: Guid) => {
        var request : StopPlayRequest = { campaignId: id };
        var result = await pauseCampaign(request);
        await this.updateList(); 
    }

    publish = async(id: Guid) => {
        var request : StopPlayRequest = { campaignId: id };
        var result = await publishCampaign(request);
        await this.updateList(); 
    }

    renderStatus = (status: CampaignStatus) => {
        switch(status){
            case CampaignStatus.Active : return <td className="status-active">Active</td>;
            case CampaignStatus.Draft : return <td className="status-draft">Draft</td>;
            case CampaignStatus.Paused : return <td className="status-paused">Paused</td>;
            case CampaignStatus.Scheduled : return <td className="status-scheduled">Scheduled</td>;
            case CampaignStatus.Expired : return <td className="status-expired">Expired</td>;
        }
    }

    renderCampaignSiteNestedPlaylists = (playlists:SiteNestedPlaylistForCampaign[]) => {
        return playlists.map( (it, index) => {
            return <p key={index}>{it.siteName} | {it.playListName}</p>
        })
    }

    lockCampaign = async (id:Guid) => {
        this.setState({showGlobalSpinner: true});
        await postCampaignLock(id);
        if(this.state.showArchivedCampaigns){
            await this.updateArchivedList();
        } else await this.updateList();
        this.setState({showGlobalSpinner: false});
    }

    unlockCampaign = async (id:Guid) => {
        this.setState({showGlobalSpinner: true});
        await postCampaignUnlock(id);
        if(this.state.showArchivedCampaigns){
            await this.updateArchivedList();
        } else await this.updateList();
        this.setState({showGlobalSpinner: false});
    }

    renderCampaignRow = (campaign : CampaingListModel) => {
        return <tr key={campaign.id}>
            <td>{campaign.campaignId ? campaign.campaignId : ''}</td>
            <td>{campaign.name}</td>
            <td>{campaign.client.name}</td>
            <td>{this.renderCampaignSiteNestedPlaylists(campaign.playLists)}</td>
            <td>                                
                {campaign.periods.map(this.renderPeriod)}
            </td>
            {this.renderStatus(campaign.status)}
            <td>{campaign.createdBy}</td>
            <td>{convertUTCDateToLocalDate(campaign.createDate)}</td>
            <td>
                {campaign.isLockedFromDeleting ? <span>
                    <IconButton type="lock" tooltipText="Release" onClick={()=>{this.unlockCampaign(campaign.id)}}/>
                </span> : <span className='opacity-50'>
                    <IconButton type="lock" tooltipText="Retain" onClick={()=>{this.lockCampaign(campaign.id)}}/>
                </span>}
                {!this.state.showArchivedCampaigns && <>
                        <IconButton type="list-add" tooltipText="Media" onClick={()=>{ this.openCampaignMediaModal(campaign.id, campaign.periods); }}/>
                        <IconButton type="edit" tooltipText="Edit" onClick={() => { this.showCreateModal(campaign)}}/>
                        {
                            (campaign.status == CampaignStatus.Draft || campaign.status == CampaignStatus.Paused) && 
                            <IconButton type="play" tooltipText="Play" onClick={() => {this.publish(campaign.id)}}/>
                        }
                        {
                            (campaign.status == CampaignStatus.Scheduled || campaign.status == CampaignStatus.Active) && 
                            <IconButton type="stop-play" tooltipText="Stop" onClick={() => {this.pause(campaign.id)}}/>
                        }                                
                        {/* <IconButton type="delete" onClick={() => {this.showDeleteModal(campaign.id, campaign.name)}}/>     */}
                        <IconButton type="archive" tooltipText="Archive" onClick={()=> this.showDeleteModal(campaign.id, campaign.name)}/>
                    </>
                }
            </td>
        </tr>
    }                          

    deleteCampaign = async () => {
        await deleteCampaign(this.state.campaignForDeleteId);
        await this.updateList();
        this.closeDeleteModal();
    }

    openCampaignMediaModal = async (id: string, campaignPeriods: CampaignPeriod[]) => {
        this.showMediaModal();
        this.setState({
            campaignId: id,
            campaignPeriods: campaignPeriods
        });
        await this.loadMediaForCampaign(id);
    }

    addChannel= (id: Guid) => this.setState({ selectedChannels: [...this.state.selectedChannels, id], isChannelsError: false});

    removeChannel = (id: Guid) => this.setState({ selectedChannels: this.state.selectedChannels.filter(it => it !== id)});

    renderItem = (a : {name : string}) => {
        return <span>{a.name}</span>
    }

    round = (value: number, size: number) => Math.round(value*Math.pow(10, size))/Math.pow(10, size); 
    
    renderMediaType = (campaignMedia: CampaignMediaItem) => {
        switch(campaignMedia.mediaType){
            case MediaType.Image : return `Image (${this.round(campaignMedia.size/1024.0/1024.0, 2)}MB)`;
            case MediaType.Video : return `Video (${this.round(campaignMedia.size/1024.0/1024.0, 2)}MB)`;
            case MediaType.VastUrl : return "VAST Url";
            case MediaType.Youtube : return "Youtube";
            case MediaType.YoutubeLive : return "Youtube Live";
            case MediaType.WebPage : return "Web Page";
            case MediaType.HiveStack : return "Hivestack";
        }
    }

    checkPeriodStatus = (period: CampaignMediaScheduleResponse) => {
        let currentDate = new Date()
        if(moment(period.end).isBefore(currentDate)){
            return "status-expired"
        }
        if(moment(currentDate).isBetween(period.start, period.end)){
            return "status-active"
        }
        return ""
    }

    renderSchedule = (periods: CampaignMediaScheduleResponse[]) => {
        let sortedPeriods = periods.sort((a, b) => moment(a.start).diff(moment(b.start)));
        return sortedPeriods.map( it => {
            let status = this.checkPeriodStatus(it)
            return <p key={it.id} className={`${status}`}>{formatDate(it.start)} - {formatDate(it.end)} {it.startTime && `${formatTimeOnly(it.startTime)} - ${formatTimeOnly(it.endTime)}`}</p>
        })
    }

    sortBySchedule = (campaignMedias : CampaignMediaItem[]) => {
        let sorted = campaignMedias.sort((a,b)=>{
            let aMinDate, bMinDate;
            aMinDate = moment.min(a.schedule.map( it => moment(it.start)));
            bMinDate = moment.min(b.schedule.map( it => moment(it.start)));
            return moment(aMinDate).diff(moment(bMinDate))
        })
        return sorted;
    }

    renderCampaignMediaTypeLink = (campaignMedia : CampaignMediaItem) => {
            switch(campaignMedia.mediaType){
                case MediaType.Image : return <span className="file-name" onClick={()=>this.showCampaignMediaInfoModal(campaignMedia.mediaId)}>{campaignMedia.name}</span>;
                case MediaType.Video : return <span className="file-name" onClick={()=>this.showCampaignMediaInfoModal(campaignMedia.mediaId)}>{campaignMedia.name}</span>
                case MediaType.VastUrl : return <span>{campaignMedia.name}</span>
                case MediaType.Youtube : return <span className="file-name" onClick={()=>this.showCampaignMediaInfoModal(campaignMedia.mediaId)}>{campaignMedia.name}</span>
                case MediaType.YoutubeLive : return <span className="file-name" onClick={()=>this.showCampaignMediaInfoModal(campaignMedia.mediaId)}>{campaignMedia.name}</span>
                case MediaType.WebPage : return <span>{campaignMedia.name}</span>
                case MediaType.HiveStack : return <span>{campaignMedia.name}</span>
            }
        }
     
    renderCampaingMediaRow = (campaignMedia : CampaignMediaItem, index: number) => {
        let classes = campaignMedia.isPaused ? 'is-paused' : '';
        return <tr className={classes}>
                    <td>{addLeadingZero(index+1, 2)}</td>
                    <td>
                        {this.renderMediaTypePreview(campaignMedia)}
                    </td>
                    <td>
                        {this.renderCampaignMediaTypeLink(campaignMedia)}
                        <p>Type: <b>{this.renderMediaType(campaignMedia)}</b></p>
                    </td>
                    <td>
                        Duration: {formatDuration(campaignMedia.durationMs)}
                    </td>
                    <td>
                        {this.renderSchedule(campaignMedia.schedule)}
                    </td>
                    <td>
                        <IconButton type="swap" tooltipText="Substitute" onClick={() => {this.showMediaLibraryForSwap(campaignMedia.id) }} />
                        <IconButton type="clock" tooltipText="Schedule" onClick={() => {this.showScheduleModal(campaignMedia.id)}} />
                        {campaignMedia.isPaused ? <IconButton tooltipText="Start" type="play" onClick={()=> this.playCampaingMedia(campaignMedia.id)} /> : 
                                                  <IconButton tooltipText="Stop" type="stop-play" onClick={()=> this.stopCampaingMedia(campaignMedia.id)} />}
                        <IconButton tooltipPosition="left" tooltipText="Delete" type="delete" onClick={() => this.deleteCampaignMedia(campaignMedia.id)} />
                    </td>
                </tr>
    }

    updateCampaignMediaSchedule = async () => {
        let result = await getCampaignMediaSchedule(this.state.campaignId, this.state.mediaIdForSetSchedule);
        if(result.type === "succes") {
            this.setState({
                campaignMediaSchedule: result.data.items
            })
        }
    }

    updateCampaignMediaScheduleByOpenScheduleModal = async (id: Guid) => {
        let result = await getCampaignMediaSchedule(this.state.campaignId,id);
        if(result.type === "succes") {
            this.setState({
                campaignMediaSchedule: result.data.items
            })
        }
    }

    showScheduleModal = async (id:Guid) => {
        this.setState({
            isShowScheduleModal:true,
            mediaIdForSetSchedule: id
        })
        await this.updateCampaignMediaScheduleByOpenScheduleModal(id);
    }

    closeScheduleModal = async () => {
        await this.loadMediaForCampaign(this.state.campaignId)
        this.setState({
            isShowScheduleModal:false,
            mediaIdForSetSchedule: ''
        })
    }

    setMediaPeriodName = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isMediaPeriodNameError: false,
            mediaPeriodName : event.target.value
        });
    }

    setMediaPeriodStart = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isMediaPeriodStartError: false,
            mediaPeriodStart : event.target.value
        });
    }

    setMediaPeriodEnd = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isPeriodEndError: false,
            isMediaPeriodEndError: false,
            mediaPeriodEnd : event.target.value
        });
    }

    setMediaPeriodStartTime = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            mediaPeriodStartTime : event.target.value
        });
    }

    setMediaPeriodEndTime = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            isMediaPeriodEndTimeError: false,
            mediaPeriodEndTime : event.target.value
        });
    }

    saveMediaPeriods = async () => {
        let isError = false;
        if(this.state.mediaPeriodName === '') {
            this.setState({isMediaPeriodNameError:true});
            isError = true
        }

        if(this.state.mediaPeriodStart === '') {
            this.setState({isMediaPeriodStartError:true});
            isError = true
        }

        if(this.state.mediaPeriodEnd === '') {
            this.setState({isMediaPeriodEndError:true});
            isError = true
        }

        if(new Date(this.state.mediaPeriodEnd) < new Date(this.state.mediaPeriodStart)){
            this.setState({isMediaPeriodEndError:true});
            isError = true
        }

        if(this.state.mediaPeriodStartTime !== ''){
            if(this.state.mediaPeriodEndTime === ''){
                this.setState({isMediaPeriodEndTimeError: true})
                isError = true
            } else {
                let [hoursStart, minutesStart] = this.state.mediaPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = this.state.mediaPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    this.setState({isMediaPeriodEndTimeError: true})
                    isError = true
                }
            }
        }
        
        if(isError) return

        let request:CampaignMediaScheduleRequest = {
            name: this.state.mediaPeriodName,
            start: this.state.mediaPeriodStart,
            end: this.state.mediaPeriodEnd,
            startTime: this.state.mediaPeriodStartTime,
            endTime: this.state.mediaPeriodEndTime
        }

        this.setState({
            showGlobalSpinner:true
        })

        let result = await postCampaignMediaSchedulePeriod(request, this.state.campaignId, this.state.mediaIdForSetSchedule);
        if(result.type === "succes") {
            await this.updateCampaignMediaSchedule();
        }

        this.setState({
            mediaPeriodName: '',
            mediaPeriodStart: '',
            mediaPeriodEnd: '',
            mediaPeriodStartTime: '',
            mediaPeriodEndTime: '',
            showGlobalSpinner: false
        })
    }

    startEditingPeriod = (period: CampaignMediaScheduleResponse) => {
        this.setState({
            editingPeriodId: period.id,
            editPeriodName: period.name,
            editPeriodStart: moment(period.start).format('YYYY-MM-DD'),
            editPeriodEnd: moment(period.end).format('YYYY-MM-DD'),
            editPeriodStartTime: period.startTime ? period.startTime : '',
            editPeriodEndTime: period.endTime ? period.endTime : '',
            isEditPeriodEndError: false,
            isEditPeriodEndTimeError: false
        });
    }

    discardEditPeriod = () => {
        this.setState({
            editingPeriodId: null,
            editPeriodName: '',
            editPeriodStart: '',
            editPeriodEnd: '',
            editPeriodStartTime: '',
            editPeriodEndTime: '',
            isEditPeriodEndError: false,
            isEditPeriodEndTimeError: false
        });
    }

    acceptEditPeriod = async () => {
        // Validate input values
        let isError = false;
        this.setState({ isEditPeriodEndError: false, isEditPeriodEndTimeError: false });
        
        if(this.state.editPeriodName === '') {
            isError = true;
        }

        if(this.state.editPeriodStart === '') {
            isError = true;
        }

        if(this.state.editPeriodEnd === '') {
            isError = true;
        }

        if(new Date(this.state.editPeriodEnd) < new Date(this.state.editPeriodStart)){
            this.setState({ isEditPeriodEndError: true });
            isError = true;
        }

        if(this.state.editPeriodStartTime !== ''){
            if(this.state.editPeriodEndTime === ''){
                this.setState({ isEditPeriodEndTimeError: true });
                isError = true;
            } else {
                let [hoursStart, minutesStart] = this.state.editPeriodStartTime.split(":").map(Number);
                let [hoursEnd, minutesEnd] = this.state.editPeriodEndTime.split(":").map(Number);
                const startMinutes = hoursStart * 60 + minutesStart;
                const endMinutes = hoursEnd * 60 + minutesEnd;

                if(endMinutes <= startMinutes){
                    this.setState({ isEditPeriodEndTimeError: true });
                    isError = true;
                }
            }
        }
        
        if(isError) return;

        this.setState({ showGlobalSpinner: true });

        // Remove old period and add updated one
        await this.removeCampaignMediaSchedulePeriod(this.state.editingPeriodId!);
        
        // Add the updated period
        let request: CampaignMediaScheduleRequest = {
            name: this.state.editPeriodName,
            start: this.state.editPeriodStart,
            end: this.state.editPeriodEnd,
            startTime: this.state.editPeriodStartTime,
            endTime: this.state.editPeriodEndTime
        }

        await postCampaignMediaSchedulePeriod(request, this.state.campaignId, this.state.mediaIdForSetSchedule);
        await this.updateCampaignMediaSchedule();
        
        this.setState({
            editingPeriodId: null,
            editPeriodName: '',
            editPeriodStart: '',
            editPeriodEnd: '',
            editPeriodStartTime: '',
            editPeriodEndTime: '',
            isEditPeriodEndError: false,
            isEditPeriodEndTimeError: false,
            showGlobalSpinner: false
        });
    }

    setEditPeriodName = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editPeriodName: event.target.value });
    }

    setEditPeriodStart = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editPeriodStart: event.target.value });
    }

    setEditPeriodEnd = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editPeriodEnd: event.target.value, isEditPeriodEndError: false });
    }

    setEditPeriodStartTime = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editPeriodStartTime: event.target.value });
    }

    setEditPeriodEndTime = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editPeriodEndTime: event.target.value, isEditPeriodEndTimeError: false });
    }

    removeCampaignMediaSchedulePeriod = async (scheduleId:Guid) => {
        await deleteCampaignMediaSchedulePeriod(this.state.campaignId, this.state.mediaIdForSetSchedule, scheduleId);
        await this.updateCampaignMediaSchedule();
    }

    duplicatePeriod = async (period: CampaignMediaScheduleResponse) => {
        this.setState({ showGlobalSpinner: true });

        let request: CampaignMediaScheduleRequest = {
            name: `${period.name} (Copy)`,
            start: moment(period.start).format('YYYY-MM-DD'),
            end: moment(period.end).format('YYYY-MM-DD'),
            startTime: period.startTime || '',
            endTime: period.endTime || ''
        }

        await postCampaignMediaSchedulePeriod(request, this.state.campaignId, this.state.mediaIdForSetSchedule);
        await this.updateCampaignMediaSchedule();
        this.setState({ showGlobalSpinner: false });
    }

    renderCampaignMediaScheduleRow = (periods: CampaignMediaScheduleResponse[]) => {
        return periods.map( it => {
            const isEditing = this.state.editingPeriodId === it.id;
            
            return <tr key={it.id}>
                <td>
                    {isEditing ? (
                        <input 
                            type="text"
                            className="form-control"
                            value={this.state.editPeriodName}
                            onChange={this.setEditPeriodName}
                            disabled={this.state.showGlobalSpinner}
                        />
                    ) : (
                        it.name
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="date"
                            className="form-control"
                            value={this.state.editPeriodStart}
                            onChange={this.setEditPeriodStart}
                            disabled={this.state.showGlobalSpinner}
                        />
                    ) : (
                        formatDate(it.start)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="date"
                                className={`form-control ${this.state.isEditPeriodEndError ? 'error' : ''}`}
                                value={this.state.editPeriodEnd}
                                onChange={this.setEditPeriodEnd}
                                disabled={this.state.showGlobalSpinner}
                            />
                            {this.state.isEditPeriodEndError && <span className="error" style={{fontSize: '12px'}}>End date must be later than start date</span>}
                        </>
                    ) : (
                        formatDate(it.end)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <input 
                            type="time"
                            className="form-control"
                            value={this.state.editPeriodStartTime}
                            onChange={this.setEditPeriodStartTime}
                            disabled={this.state.showGlobalSpinner}
                        />
                    ) : (
                        formatTimeOnly(it.startTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <input 
                                type="time"
                                className={`form-control ${this.state.isEditPeriodEndTimeError ? 'error' : ''}`}
                                value={this.state.editPeriodEndTime}
                                onChange={this.setEditPeriodEndTime}
                                disabled={this.state.showGlobalSpinner}
                            />
                            {this.state.isEditPeriodEndTimeError && <span className="error" style={{fontSize: '12px'}}>End time must be later than start time</span>}
                        </>
                    ) : (
                        formatTimeOnly(it.endTime)
                    )}
                </td>
                <td>
                    {isEditing ? (
                        <>
                            <IconButton type="save" tooltipText="Accept" onClick={this.acceptEditPeriod} disabled={this.state.showGlobalSpinner} />
                            <IconButton type="cross" tooltipText="Discard" onClick={this.discardEditPeriod} disabled={this.state.showGlobalSpinner} />
                        </>
                    ) : (
                        <>
                            <IconButton type="edit" tooltipText="Edit" onClick={() => this.startEditingPeriod(it)} />
                            <IconButton type="copy" tooltipText="Duplicate" onClick={() => this.duplicatePeriod(it)} />
                            <IconButton type="delete" tooltipText="Delete" tooltipPosition="left" onClick={()=>{
                                this.removeCampaignMediaSchedulePeriod(it.id)}
                            }/>
                        </>
                    )}
                </td>
            </tr>
        })
    }


    deleteCampaignMedia = async (campaignMediaId : Guid) => {
        this.setState({showGlobalSpinner: true});
        await deleteCampaignMedia(campaignMediaId);
        
        await this.loadMediaForCampaign(this.state.campaignId);
        this.setState({showGlobalSpinner: false});
    }

    playCampaingMedia = (id: Guid) => this.changeStatusCampaignMedia(id, "play");
    stopCampaingMedia = (id: Guid) => this.changeStatusCampaignMedia(id, "stop");
    
    changeStatusCampaignMedia = async(id: Guid, action: "play" | "stop") => {
        var request : ChangeStatusCampaignMediaRequest = { campaignMediaId: id };
        var apiFunction = action == "play" ? playCampaignMedia : pauseCampaignMedia;
        this.setState({showGlobalSpinner: true});
        var result = await apiFunction(request);
        if( result.type = "succes") {
            await this.loadMediaForCampaign(this.state.campaignId)
        }
        this.setState({showGlobalSpinner: false});
    }

    loadMediaForCampaign = async (id: Guid) => {
        var getMediaResponse = await getCampaignMedia(id);
        if(getMediaResponse.type == "succes"){
            let filteredMedia = getMediaResponse.data.media.filter(it => it.deleteDate === null);
            this.setState({ campaignMedia : filteredMedia})
        }
    }

    renderMediaLibraryItem = (item: {mediaType: MediaType, number?: number, previewLink: string, fileName: string, id: string}) => {
        const className = `media-elem ${item.number && "checked"}`
        return     <div className={className} onClick={() => this.addOrRemoveMedia(item.id)}>
                        <span className="check-elem">{item.number}</span>
                        {this.renderMediaTypePreviewModal(item.mediaType, item.previewLink)}
                        <p className="media-title">{item.fileName}</p>
                    </div>
    }

    addOrRemoveMedia = (id: string) => {
        if (this.state.isSwapModeActive) {
            if (this.state.selectedMedia.length > 0 && this.state.selectedMedia[0].id === id) {
                return;
            }

            this.setState({
                selectedMedia: [{ id, index: 1 }]
            });

            return;
        } else {
            var selectedMedia = this.state.selectedMedia;
            for( var i = 0; i < selectedMedia.length; i++){
                if (selectedMedia[i].id === id) {
                    selectedMedia.splice(i, 1); 
                    for(var decreaseId = i; decreaseId < selectedMedia.length; decreaseId++){
                        selectedMedia[decreaseId].index = selectedMedia[decreaseId].index-1;                 
                    }
                    this.setState({selectedMedia: selectedMedia});
                    return;
                }        
            }
            
            var maxIndex = selectedMedia.length === 0 ?  0 : Math.max(...selectedMedia.map(it => it.index));
            selectedMedia.push({id: id, index: maxIndex+1});
            this.setState({selectedMedia: selectedMedia});
        }
    }

    addMediaToCampaign = async () => {
        const request : AddCampaignMediaRequest = {
            campaignId : this.state.campaignId,
            mediaIds: this.state.selectedMedia.map(it => it.id)
        };

        const result = await addCampaignMedia(request); 

        if(result.type === "succes"){
            this.setState({selectedMedia : []});
            await this.loadMediaForCampaign(this.state.campaignId);
            this.closeMediaLibrary();
        }
    }

    swapMediaInCampaign = async () => {
        const request : SwapCampaignMediaRequest = {
            campaignId : this.state.campaignId,
            mediaIdToSwap : this.state.swappedMediaId,
            mediaId: this.state.selectedMedia[0].id
        };

        const result = await swapCampaignMedia(request); 

        if(result.type === "succes"){
            this.setState({selectedMedia : []});
            await this.loadMediaForCampaign(this.state.campaignId);
            this.closeMediaLibrary();
        }
    }

    getNumberOfSelectedMedia = (id: string): number | undefined => {
        var element = this.state.selectedMedia.find(it => it.id === id);
        return element && element.index;
    }

    showCreateModal = (campaign?: CampaingListModel) =>  { 
        if (campaign === undefined) {
            this.setState({campaignForEdit: undefined})
        } else {
            this.setState({
                campaignForEdit: campaign
            })
        }

        this.setState({showCampaignModal: true}); 
    } 

    closeCampaignModal = () => {
        this.setState({
            showCampaignModal: false,
            campaignForEdit: undefined
        })
    };  

    showMediaModal = () => this.setState({showMediaModal: true});  
    closeMediaModal = async () => this.setState({showMediaModal: false});

    showMediaLibrary = async () => {
        this.setState({showGlobalSpinner: true})
        var getMediaResponse = await getMedia();
        if(getMediaResponse.type == "succes"){
            this.setState({
                media: getMediaResponse.data.medias,
                currentPage: 1,
                isShowMedia: true,
                showGlobalSpinner: false
            });
        }
    }
    closeMediaLibrary = () => this.setState({isShowMedia: false, selectedMedia:[], isSwapModeActive:false, swappedMediaId: ''});

    showMediaLibraryForSwap = async (campaignMediaId: Guid) => {
        this.setState({isSwapModeActive: true, swappedMediaId: campaignMediaId})
        await this.showMediaLibrary()
    }

    showDeleteModal = (id: Guid, name: string) => this.setState({showDeleteModal : true, campaignForDeleteId: id, campaignForDelete: name});
    closeDeleteModal = () => this.setState({showDeleteModal : false, campaignForDeleteId: ""});

    setSearchString = (search: string) => {
        this.setState({
            searchString: search,
            currentPage: 1,
        })
    }

    setSearchCampaignNameString = (search: string) => {
        this.setState({
            searchCampaignNameString : search,
            currentPageOfCamapigns: 1
        })
    }

    getMediaPagesNumber = () => {
        let length = this.getFilteredBySearch().length;
        return getPagesCount(length, this.mediaItemsPerPage)
    }

    getCampaignPagesNumber = () => {
        let length = this.getCampaignsToDisplay().totalCount;
        return getPagesCount(length, this.camapignPerPage)
    }

    getCampaignsToDisplay = () => {
        let filteredCampaigns = this.getFilteredByCampaignName();

        filteredCampaigns = this.getFilteredByCampaignStatus(filteredCampaigns);
        let startIndex = (this.state.currentPageOfCamapigns - 1)*this.camapignPerPage;
        let finishIndex = startIndex + this.camapignPerPage;
        return {
            items: filteredCampaigns.slice(startIndex, finishIndex),
            totalCount: filteredCampaigns.length
        }
    }

    getFilteredByCampaignStatus = (campaigns: CampaingListModel[]) => {
        if(this.state.selectedStatusOption){
            return campaigns.filter( it => it.status === this.state.selectedStatusOption)
        }
        return campaigns
    }
 
    getFilteredByCampaignName = () => {
        return this.state.searchCampaignNameString === '' 
        ? this.state.campaigns 
        : this.state.campaigns.filter(
                 it => (!!it.name && it.name.toLowerCase().includes(this.state.searchCampaignNameString.toLowerCase()))
                || (it.campaignId && it.campaignId.toLowerCase().includes(this.state.searchCampaignNameString.toLowerCase()))
                || (it.createdBy && it.createdBy.toLowerCase().includes(this.state.searchCampaignNameString.toLowerCase()))
            );
    }

    getMediaItemsToDisplay = () => {
        var filteredBySearch = this.getFilteredBySearch();
        let startIndex = (this.state.currentPage - 1)*this.mediaItemsPerPage;
        let finishIndex = startIndex + this.mediaItemsPerPage;
        return filteredBySearch.slice(startIndex, finishIndex) 
    }

    getFilteredBySearch = () => {
        return this.state.searchString === '' 
        ? this.state.media 
        : this.state.media.filter(it => !!it.name && it.name.toLowerCase().includes(this.state.searchString.toLowerCase()))
    }

    changePaginationPage = (currentPage: number) => {
        this.setState({currentPage: currentPage})
    }

    changePaginationPageOfCampaigns = (currentPage: number) => {
        this.setState({currentPageOfCamapigns: currentPage})
    }

    async onSelectMediaForCampaign(event: React.ChangeEvent<HTMLInputElement>): Promise<void>{
        if(event.target.files){
            const formData = new FormData();
            this.setState({showGlobalSpinner : true})
            formData.append("Media", event.target.files[0] )
            await uploadMediaForCampaign(formData, this.state.campaignId);
            await this.loadMediaForCampaign( this.state.campaignId);
            this.setState({showGlobalSpinner : false})
        }
    }

    closeVASTModal = () => { this.setState({
        showVASTModal: false,
        vastName:'',
        isVastNameError: false,
        vastUrl:'',
        isVastUrlError:false,
        selectedContentTypeOption: mediaContentTypeOptions[0],
        selectedMediaCategory: null
    })};
    
    showVASTModal = () => { this.setState({showVASTModal: true})};

    setVastName = (newName: string) => { this.setState({vastName: newName, isVastNameError: false})}
    setVastUrl = (newUrl: string) => { this.setState({vastUrl: newUrl, isVastUrlError: false})}
    setClockID = (newID: string) => { this.setState({clockID: newID})}

    saveVastUrl = async () => {
        let isValid = true;
        if(!this.state.vastName) { this.setState({isVastNameError : true}); isValid = false; }
        if(!this.state.vastUrl) { this.setState({isVastUrlError : true}); isValid = false; }

        if(!isValid) return
        this.setState({showGlobalSpinner: true});
        let request = { 
            name: this.state.vastName,
            url: this.state.vastUrl, 
            contentType: this.state.selectedContentTypeOption!.type, 
            clockID: this.state.clockID, 
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }
        let result = await postMediaCampaignVast(request, this.state.campaignId);
        if(result.type == "succes") {
            this.closeVASTModal();
            await this.loadMediaForCampaign( this.state.campaignId);
        }
        this.setState({showGlobalSpinner:false})
    }

    showHiveStackModal = () => { this.setState({showHiveStackModal: true})};
    closeHiveStackModal = () => { 
        this.setState({
            showHiveStackModal: false, 
            isHiveStackNameError:false, 
            hiveStackName: "",
            selectedHiveStackContentTypeOption: mediaContentTypeOptions[0],
            hiveStackClockId: "",
            selectedMediaCategory: null
        })
    };

    saveHiveStack = async () => {
        let isValid = true;
        if(!this.state.hiveStackName) { this.setState({isHiveStackNameError : true}); isValid = false; }

        if(!isValid) return
        this.setState({showGlobalSpinner: true});
        let request: HiveStackRequest = { 
            name: this.state.hiveStackName, 
            contentType: this.state.selectedHiveStackContentTypeOption!.type,
            clockID: this.state.hiveStackClockId,
            taxonomiesCategoryId: this.state.selectedMediaCategory ? this.state.selectedMediaCategory.value : null
        }

        let result = await postCampaignHiveStack(request, this.state.campaignId);
        if(result.type == "succes") {
            this.closeHiveStackModal();
            await this.loadMediaForCampaign( this.state.campaignId);
        }
        this.setState({showGlobalSpinner:false})
    }

    onSelectedHiveStackContentType = (newValue: SingleValue<MediaContentTypeOption>) => {
        this.setState({ selectedHiveStackContentTypeOption: newValue})
    }
    
    setHiveStackName = (newName: string) => { this.setState({hiveStackName: newName, isHiveStackNameError: false})}
    setHiveStackClockId = (clockId:string) => {this.setState({hiveStackClockId: clockId})}


    getMediaInfoById = async (id:Guid) => {
        let mediaInfoResponse = await getMediaById(id);
        if(mediaInfoResponse.type == "succes"){
            this.setState({mediaInfo: mediaInfoResponse.data.data});
        }
    }

    closeCampaignMediaInfoModal = () => {
        let video = document.querySelector('video');
        video?.pause();
        video && (video.currentTime = 0);
        this.setState({showCampaignMediaInfoModal: false})
    };

    showCampaignMediaInfoModal = async (campaignMediaId: Guid) => { 
        this.setState({showGlobalSpinner:true})
        await this.getMediaInfoById(campaignMediaId);
        this.setState({
            showGlobalSpinner:false,
            showCampaignMediaInfoModal: true
        })
    };

    onUpdateMediaInfo = async (id: string, newName: string, newDuration: number, mediaType: MediaType, label : MediaContentType | null, clockID: string, mediaCateforyId: number | null)=>{
        this.setState({showGlobalSpinner: true})
        mediaType === MediaType.Image ? (
            await updateMedia(id,{newName: newName, newDurationMs: newDuration, contentType: label, clockID: clockID, taxonomiesCategoryId: mediaCateforyId})
        ):(
            await updateMedia(id,{newName: newName, contentType: label, clockID: clockID, taxonomiesCategoryId: mediaCateforyId})
        )
        await this.loadMediaForCampaign(this.state.campaignId);
        this.setState({showGlobalSpinner: false, showCampaignMediaInfoModal: false});
    };

    renderMediaTypePreview = (media: CampaignMediaItem) => {
        switch(media.mediaType){
            case MediaType.Image : return <img className="sortable__item-img" src={media.thumbnailUrl} alt="" />
            case MediaType.Video : return <img className="sortable__item-img" src={media.thumbnailUrl} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" color="#ff0000" />;
            case MediaType.Youtube : return <img className="sortable__item-img" src={media.thumbnailUrl} alt="" />;
            case MediaType.YoutubeLive : return <img className="sortable__item-img" src={media.thumbnailUrl} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" color="red" />;
            case MediaType.HiveStack : return <img className="sortable__item-img" src={hiveStackIMG} alt="" />;
        }
    }

    renderMediaTypePreviewModal = (type: MediaType, url: string) => {
        switch(type){
            case MediaType.Image : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.Video : return <img className="media-img-preview" src={url} alt="" />
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.YoutubeLive : return <img className="media-img-preview" src={url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
            case MediaType.HiveStack : return <img className="media-img-preview" src={hiveStackIMG} alt="" />;
        }
    }

    onSelectedMediaLabel = (newValue: SingleValue<MediaContentTypeOption>) => {
        this.setState({ selectedContentTypeOption: newValue})
    }

    onSelectedStatusOption = (newValue: SingleValue<{type:CampaignStatus, name: string}>) => {
        this.setState({ 
            selectedStatusOption: newValue?.type, 
            currentPageOfCamapigns: 1
        })
    }

    onChangeSelectedMediaCategory = (newValue: SingleValue<Option<number>>) => {
        this.setState({selectedMediaCategory: newValue})
    }

    render() {
        let campaignListLength = this.getCampaignsToDisplay().totalCount
        return <InnerLayout 
        activeTab="campaigns" 
        logOut={this.props.logOut} 
        toogleCollapse={this.props.toogleCollapse}
        isCollapsed={this.props.isCollapsed}
        >
            <>
                <GlobalSpinner isShow={this.state.showGlobalSpinner}/>
                
                    <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                    <div className="d-flex">
                        {this.state.showArchivedCampaigns ? 
                            <Button color="green"  label="Show ACTIVE Campaigns" onClick={this.updateList} /> : 
                            <Button color="green"  label="Show ARCHIVED Campaigns" onClick={this.showArchivedCampaignsList} />
                        }
                        
                    </div>
                    <div className="d-flex">
                        <div className="d-flex align-items-center gap5" style={{width:"250px", marginRight:"15px"}}>
                            <label>Status</label>
                            <Select 
                                options={this.statusOptions}
                                className={`w-100`}
                                classNamePrefix={`select`}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedStatusOption} 
                                isClearable={true}
                            /> 
                        </div>
                        <Search onChangeValue={this.setSearchCampaignNameString} />
                        <Button color="green"  label="Add Campaign" onClick={this.showCreateModal} />
                    </div>
                    </div>

                    {campaignListLength ? <table className="table">
                        <thead>
                            <tr>
                                <td>Campaign ID</td>
                                <td>Campaign </td>
                                <td>Client</td>
                                <td>Networks | Playlists </td>
                                <td>Periods</td>
                                <td>Status</td>
                                <td>Created By</td>
                                <td>Created On</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getCampaignsToDisplay().items.map(this.renderCampaignRow)}
                        </tbody>
                    </table> : <p className="w-100 text-center">There are no Campaigns</p>}

                    <Pagination 
                        isShow={!!campaignListLength}
                        activePage={this.state.currentPageOfCamapigns} 
                        pagesCount={this.getCampaignPagesNumber()} 
                        changePaginationPage={this.changePaginationPageOfCampaigns} 
                    />

                    <CampaignModal
                        campaign = {this.state.campaignForEdit}
                        showCampaignModal = {this.state.showCampaignModal}
                        closeCampaignModal = {this.closeCampaignModal}
                        updateCampaignListFunction = {this.updateList}
                    />

                    <CenterModal 
                        title="Campaign Media"
                        show={this.state.showMediaModal}
                        onRequestClose={this.closeMediaModal}
                    >
                        <>
                        <div className={`d-flex justify-content-${this.state.isShowMedia ? 'between' : 'end'} align-items-center mb-40 `}>
                            { this.state.isShowMedia && <Search value={this.state.searchString} onChangeValue={this.setSearchString} />}
                            { !this.state.isShowMedia && <>
                                <Button color="green"  label="Add Hivestack" onClick={this.showHiveStackModal} /> &nbsp;&nbsp;
                                <SelectMultipleFileButton 
                                    title="Add Media" 
                                    campaignId={this.state.campaignId} 
                                    onMediaUploaded={()=>this.loadMediaForCampaign(this.state.campaignId)} 
                                />&nbsp;&nbsp;
                                <Button color="green"  label="Add Vast" onClick={this.showVASTModal} /> &nbsp;&nbsp;
                                <Button color="green"  label="Select Media" onClick={this.showMediaLibrary} />
                            </> }
                        </div>
                        {!this.state.isShowMedia &&
                            <table className="table modal-table media-list-table">
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>File</td>
                                        <td>Details</td>
                                        <td>Schedule</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.sortBySchedule(this.state.campaignMedia).map(this.renderCampaingMediaRow)}
                                </tbody>
                            </table>
                        }
                        {this.state.isShowMedia && <>
                            <div className="media-library">
                                {this.getMediaItemsToDisplay().map(
                                    it => this.renderMediaLibraryItem(
                                        {
                                            mediaType: it.mediaType,
                                            fileName: it.name, 
                                            previewLink: it.previewLink, 
                                            id: it.id, 
                                            number: this.getNumberOfSelectedMedia(it.id)}))}                              
                            </div>
                            
                            <Pagination 
                                activePage={this.state.currentPage} 
                                pagesCount={this.getMediaPagesNumber()} 
                                changePaginationPage={this.changePaginationPage} 
                            />

                            <div className="modal-btn-group">
                                {this.state.isSwapModeActive ? 
                                    <Button color="green" label="Substitute" onClick={()=>{this.swapMediaInCampaign()}} /> 
                                    : 
                                    <Button color="green" label="Add" onClick={()=>{this.addMediaToCampaign()}} />
                                }
                                <Button color="gray" label="Cancel" onClick={this.closeMediaLibrary} />
                            </div>
                            </>}
                        </>
                    </CenterModal>  

                    <CenterModal title="Campaign Media Info" show={this.state.showCampaignMediaInfoModal} onRequestClose={this.closeCampaignMediaInfoModal}>
                        {this.state.mediaInfo ? <FileInfoImage mediaInfo={this.state.mediaInfo} mediaCategories={this.state.mediaCategories} mode="edit" onUpdateMediaInfo={this.onUpdateMediaInfo} /> : 
                            <h1>Media info is undefined</h1>
                        }
                    </CenterModal> 

                    <SmallModal show={this.state.showDeleteModal} onRequestClose={this.closeDeleteModal}> 
                        <p>That you want to archive campaign <b>{this.state.campaignForDelete}</b>?</p>
                        <div className="modal-btn-group">
                            <Button color="gray" label="Cancel" onClick={this.closeDeleteModal}/>
                            <Button color="green" label="Yes" onClick={this.deleteCampaign}/>
                        </div>
                    </SmallModal>

                    <RightModal title="VAST" show={this.state.showVASTModal} onRequestClose={this.closeVASTModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="name-id"
                                value={this.state.vastName} 
                                isError={this.state.isVastNameError} 
                                errorMessage="Invalid vast name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setVastName} 
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="URL" 
                                id="url-id" 
                                value={this.state.vastUrl} 
                                isError={this.state.isVastUrlError} 
                                errorMessage="Invalid vast url" 
                                onChange={()=>{}} 
                                onChangeValue={this.setVastUrl} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Content Type</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={mediaContentTypeOptions}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedMediaLabel}
                                value={this.state.selectedContentTypeOption}
                                isMulti={false}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="Clock ID" 
                                id="clock-id"
                                value={this.state.clockID} 
                                isError={false} 
                                errorMessage="" 
                                onChange={()=>{}} 
                                onChangeValue={this.setClockID} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveVastUrl}/>
                            <Button color="gray" label="Cancel" onClick={this.closeVASTModal}/>
                        </div>
                    </RightModal> 

                    <RightModal title="Hivestack" show={this.state.showHiveStackModal} onRequestClose={this.closeHiveStackModal}>
                        <FormRow>
                            <FormInput 
                                title="Name" 
                                id="hivestack-name-id"
                                value={this.state.hiveStackName} 
                                isError={this.state.isHiveStackNameError} 
                                errorMessage="Invalid Hivestack name" 
                                onChange={()=>{}} 
                                onChangeValue={this.setHiveStackName} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Content Type</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={mediaContentTypeOptions}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.type}`}
                                onChange={this.onSelectedHiveStackContentType}
                                value={this.state.selectedHiveStackContentTypeOption}
                                isMulti={false}
                            />
                        </FormRow>
                        <FormRow>
                            <FormInput 
                                title="Clock ID" 
                                id="hivestack-clock-id"
                                value={this.state.hiveStackClockId} 
                                isError={false} 
                                errorMessage="" 
                                onChange={()=>{}} 
                                onChangeValue={this.setHiveStackClockId} 
                            />
                        </FormRow>
                        <FormRow>
                            <label>Media Category</label>
                            <Select
                                className={`w-100`}
                                classNamePrefix={`select`}
                                options={this.state.mediaCategories}
                                onChange={this.onChangeSelectedMediaCategory}
                                value={this.state.selectedMediaCategory}
                                isMulti={false}
                                isClearable
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.saveHiveStack}/>
                            <Button color="gray" label="Cancel" onClick={this.closeHiveStackModal}/>
                        </div>
                    </RightModal>  

                    <CenterModal title="Media Schedule" show={this.state.isShowScheduleModal} onRequestClose={this.closeScheduleModal}>
                        <div className="mosaic-period-wrapper">
                            <div className="mosaic-period-inputs">
                                <div>
                                    <FormInput 
                                        errorMessage = "Please enter name"
                                        id = "period_name"
                                        isError = {this.state.isMediaPeriodNameError}
                                        title = "Name"
                                        onChange = {this.setMediaPeriodName}
                                        value = {this.state.mediaPeriodName}
                                    />
                                </div>
                                <div className="">
                                    <label htmlFor="start">Start Date</label>
                                    <input 
                                        type="date" 
                                        className={`form-control ${this.state.isMediaPeriodStartError ? "error" : ""}`}  
                                        name="" 
                                        id="start" 
                                        onChange={this.setMediaPeriodStart}
                                        value={this.state.mediaPeriodStart}
                                    />
                                    {this.state.isMediaPeriodStartError && <span className="error">Please select start period</span>}
                                </div>
                                <div className="">
                                    <label htmlFor="ends">End Date</label>
                                    <input 
                                        type="date" 
                                        className={`form-control ${this.state.isMediaPeriodEndError ? "error" : ""}`}  
                                        name="" 
                                        id="ends" 
                                        onChange={this.setMediaPeriodEnd}
                                        value={this.state.mediaPeriodEnd}
                                        min={this.state.mediaPeriodStart}
                                        disabled={!!!this.state.mediaPeriodStart}
                                    />
                                    {this.state.isMediaPeriodEndError && <span className="error">End period should be later than start period</span>}
                                </div>
                                <div className="">
                                    <label htmlFor="start-time">Start Time</label>
                                    <input 
                                        type="time" 
                                        className={`form-control`}  
                                        name="" 
                                        id="start-time" 
                                        onChange={this.setMediaPeriodStartTime}
                                        value={this.state.mediaPeriodStartTime}
                                    />
                                </div>
                                <div className="">
                                    <label htmlFor="ends-time">End Time</label>
                                    <input 
                                        type="time" 
                                        className={`form-control ${this.state.isMediaPeriodEndTimeError ? "error" : ""}`}  
                                        name="" 
                                        id="ends-time" 
                                        onChange={this.setMediaPeriodEndTime}
                                        value={this.state.mediaPeriodEndTime}
                                    />
                                    {this.state.isMediaPeriodEndTimeError && <span className="error">End period should be later than start period</span>}
                                </div>
                                <div className="">
                                    <Button color="green" label="Add" onClick={this.saveMediaPeriods}/>
                                </div>
                            </div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>Start Date</td>
                                        <td>End Date</td>
                                        <td>Start Time</td>
                                        <td>End Time</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderCampaignMediaScheduleRow(
                                        this.state.campaignMediaSchedule.sort((a, b) => a.name.localeCompare(b.name))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </CenterModal>
            </>
            </InnerLayout>
    }
}

export default withRouter(Campaigns);